"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var icons_1 = require("../../icons");
var layout_1 = require("../layout");
var __1 = require("../");
var variables_1 = require("../../style/variables");
var style_1 = require("../../style");
var TYPE_TO_COLOR = {
    primary: variables_1.ThemeColor.Primary,
    success: variables_1.ThemeColor.Success,
    warning: variables_1.ThemeColor.Warning,
    error: variables_1.ThemeColor.Error,
};
var SIZE_CONFIG_MAP = {
    sm: {
        container: react_1.css({
            gap: 8,
            padding: 10,
            borderRadius: "var(" + variables_1.BorderRadius.sm + ")",
        }),
        titleFontSize: style_1.pxToRem(12, 16),
        descriptionFontSize: 'sm',
        iconSize: 16,
    },
    md: {
        container: react_1.css({
            gap: 12,
            padding: 16,
            borderRadius: "var(" + variables_1.BorderRadius.md + ")",
        }),
        titleFontSize: style_1.pxToRem(14, 16),
        descriptionFontSize: 'default',
        iconSize: 20,
    },
};
var ICON = {
    primary: icons_1.InfoCircle,
    success: icons_1.CheckCircle,
    warning: icons_1.AlertTriangle,
    error: icons_1.AlertCircle,
};
var Alert = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'primary' : _b, _c = _a.size, size = _c === void 0 ? 'md' : _c, titleText = _a.titleText, onDismiss = _a.onDismiss, _d = _a.icon, Icon = _d === void 0 ? ICON[type] : _d, description = _a.description, actionText = _a.actionText, onActionClicked = _a.onActionClicked, props = __rest(_a, ["type", "size", "titleText", "onDismiss", "icon", "description", "actionText", "onActionClicked"]);
    var typeColor = TYPE_TO_COLOR[type];
    var sizeConfig = SIZE_CONFIG_MAP[size];
    return (react_1.jsx(layout_1.Flex, __assign({}, props, { css: [
            sizeConfig.container,
            {
                border: "1px solid var(" + typeColor.LIGHT_2 + ")",
                background: "var(" + typeColor.LIGHT_6 + ")",
            },
        ] }),
        react_1.jsx(Icon, { size: sizeConfig.iconSize, css: {
                minWidth: sizeConfig.iconSize,
                minHeight: sizeConfig.iconSize,
                color: "var(" + typeColor.DARK_1 + ")",
            } }),
        react_1.jsx(layout_1.Flex, { gap: 12, direction: "column", css: { flex: 1 } },
            react_1.jsx(layout_1.Flex, { gap: 4, direction: "column" },
                react_1.jsx(__1.Text, { color: "var(" + typeColor.DARK_2 + ")", size: sizeConfig.titleFontSize }, titleText),
                description ? (react_1.jsx(__1.Text.Body, { size: sizeConfig.descriptionFontSize, color: "var(" + typeColor.DARK_1 + ")" }, description)) : null),
            actionText && size !== 'sm' ? (react_1.jsx(layout_1.Flex, { gap: 8, alignItems: "center", css: { color: "var(" + typeColor.DARK_2 + ")", cursor: 'pointer' }, onClick: onActionClicked },
                react_1.jsx(__1.Text.Body, { color: "inherit" }, actionText),
                react_1.jsx(icons_1.ArrowNarrowRight, { size: 16 }))) : null),
        onDismiss ? (react_1.jsx(icons_1.XClose, { onClick: onDismiss, size: sizeConfig.iconSize, cursor: "pointer", css: {
                minWidth: sizeConfig.iconSize,
                minHeight: sizeConfig.iconSize,
                color: "var(" + typeColor.DARK_1 + ")",
                ':hover': {
                    color: "var(" + typeColor.DARK_3 + ")",
                },
            } })) : null));
};
exports.default = Alert;
